import React from 'react';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';
import './style.scss';

const TextLengthTooltip = ({ name, maxLength, className }) => {
  if (name.length > maxLength) {
    return (
      <>
        <span className={className} data-tip={name}>
          {name}
        </span>
        <ReactTooltip
          className="tooltip-text"
          type="dark"
          place="bottom"
          effect="solid"
        />
      </>
    );
  } else {
    return <span className={className}>{name}</span>;
  }
};

TextLengthTooltip.propTypes = {
  name: PropTypes.string.isRequired,
  maxLength: PropTypes.number.isRequired,
  className: PropTypes.string
};

export default TextLengthTooltip;
